module.exports = __webpack_public_path__ + "img/1149.dfaa4508.gif";